// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const TABLE_ACTIONS = {
    EDIT: 'edit-additional-disk',
    RESIZE: 'resize-additional-disk',
    REMOVE: 'remove-additional-disk',
};